import { useEffect } from 'react';

/**
 * Scroll-reveal engine: adds `is-in` to every `.reveal` element inside the
 * container the first time it enters the viewport. IntersectionObserver only —
 * no scroll listeners, no layout thrash — and a no-op under reduced motion.
 */
export const useReveal = (deps = []) => {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
      return undefined;
    }

    const targets = Array.from(document.querySelectorAll('.reveal:not(.is-in)'));
    if (!targets.length) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );

    targets.forEach((t) => io.observe(t));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useReveal;
